import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Store";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import DownloadSkillsReview from "./DownloadSkillsReview";
import ReviewEmployeesSkills from "./ReviewEmployeesSkills";
import SkillsView from "./SkillsView";
import SkillHistory from "./SkillHistory";
import SkillDocument from "./SkillDocument";
import UploadedDocuments from "./UploadedDocuments";
import EmployeesWithNoSkillResponses from "./EmployeesWithNoSkillResponses";
import Footer from "../../components/Page Component/Footer";
import Navbar from "../../components/Page Component/Navbar";
 

const ViewAllSkills = () => {
  const [value, setValue] = React.useState(0);

  // Use current acting role from Redux; fallback to persisted selectedRole
  const selectedRoleFromStore = useSelector((state: RootState) => state.auth.selectedRole);
  const selectedRole = selectedRoleFromStore || localStorage.getItem("selectedRole") || "";
  const isHR = selectedRole.toLowerCase() === "hr";

  // Pure state: default to 0; clamp to allowed tabs for non-HR on change

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // Non-HR users can only access tabs 0, 1, 2 (Review Skills, Download Review, History)
    if (!isHR && newValue > 2) {
      setValue(0);
    } else {
      setValue(newValue);
    }
  };
  

  return (
    <Box sx={{ width: "100%", mt: 10, mb: 10 }}>
      
      {/* Tabs Section */}
      <Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          textColor="inherit"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
            "& .MuiTab-root": { color: "black" },
            "& .Mui-selected": { color: "black" },
          }}
        >
          <Tab {...a11yProps(0)} label={"Review Skills"} />
          <Tab {...a11yProps(1)} label={"Download Review"} />
          <Tab {...a11yProps(2)} label={"History"} />
          {isHR && (
            <Tab {...a11yProps(3)} label={"Skills Pending"} />
          )}
          {isHR && (
            <Tab {...a11yProps(4)} label={"Add Skills"} />
          )}
          {isHR && (
            <Tab {...a11yProps(5)} label={"Skills Document Upload"} />
          )}
          {isHR && (
            <Tab {...a11yProps(6)} label={"Uploaded Documents"} />
          )}
        </Tabs>
      </Box>

      {/* Content Section */}
      <Box sx={{ width: "100%", mt: 3 }}>
        <CustomTabPanel value={value} index={0}>
          <ReviewEmployeesSkills />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <DownloadSkillsReview />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <SkillHistory />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          {isHR && <EmployeesWithNoSkillResponses />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          {isHR && <SkillsView />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          {isHR && <SkillDocument />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
          {isHR && <UploadedDocuments />}
        </CustomTabPanel>
      </Box>
      
    </Box>
  );
};

export default ViewAllSkills;
